import { render, staticRenderFns } from "./DocPassportCopy.vue?vue&type=template&id=8ff7c906&"
import script from "./DocPassportCopy.vue?vue&type=script&lang=js&"
export * from "./DocPassportCopy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports